import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MaterialStore, MaterialState } from './materials.store';
import { Material } from 'src/app/models/material.model';

@Injectable({ providedIn: 'root' })
export class MaterialQuery extends QueryEntity<MaterialState> {
  constructor(protected override store: MaterialStore) {
    super(store);
  }

  selectMaterialsByFinalProductId(finalProductId: number) {
    return this.selectAll({
      filterBy: entity => this.getValue().finalProductId === finalProductId
    });
  }

  /**
   * Check if the store already contains materials for the finalProductId.
   */
  hasMaterialsForFinalProduct(finalProductId: number): boolean {
    const state = this.getValue();
    return state.finalProductId === finalProductId && this.hasEntity();
  }
}
